import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    const savedTheme = localStorage.getItem("adminTheme") || "dark";
    this.setTheme(savedTheme);
    this.element.checked = savedTheme === "light";
  }

  toggle() {
    const newTheme = this.element.checked ? "light" : "dark";
    this.setTheme(newTheme);
    localStorage.setItem("adminTheme", newTheme);
  }

  setTheme(theme) {
    if (theme === "dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }
}
